import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/about_banner.png';
const _withScopeId = n => (_pushScopeId("data-v-ba3abea4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "web-banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "banner-word flex align-items"
}, [/*#__PURE__*/_createElementVNode("h3", null, "爱沃客"), /*#__PURE__*/_createElementVNode("h4", null, "IWOWKE")])], -1));
const _hoisted_3 = {
  class: "company-honor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_header = _resolveComponent("top-header");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_about_tab = _resolveComponent("about-tab");
  const _component_honor_medal = _resolveComponent("honor-medal");
  const _component_bottom_foot = _resolveComponent("bottom-foot");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_top_header, {
      scenario: $data.scenario
    }, null, 8, ["scenario"])]),
    _: 1
  }), _hoisted_2, _createVNode(_component_about_tab, {
    scenario: $data.scenario
  }, null, 8, ["scenario"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_honor_medal, {
    list: $data.data
  }, null, 8, ["list"])]), _createVNode(_component_bottom_foot)]);
}